export const BANNER_IMAGE =
  'https://pastatic.picsart.com/cms-pastatic/5d2b55ae-4494-434c-a21a-79c13f7809ed.png';
export const INPUT_PLACEHOLDER = 'Search sizes';
export const DEFAULT_PATH = 'sizes/';
